// Centralized provider metadata (name, icon, color)
import { SiGoogle, SiOpenai, SiAmazonwebservices } from 'react-icons/si';

export const PROVIDER_MAP = {
  vertex_ai: { id: 'vertex_ai', name: 'Google Vertex AI', color: '#4285f4', icon: SiGoogle },
  vertex_ai_vision: { id: 'vertex_ai_vision', name: 'Google Vertex AI', color: '#4285f4', icon: SiGoogle },
  google_video_intelligence: { id: 'google_video_intelligence', name: 'Google Video Intelligence', color: '#0F9D58', icon: SiGoogle },
  openai: { id: 'openai', name: 'OpenAI', color: '#00a67e', icon: SiOpenai },
  aws_bedrock: { id: 'aws_bedrock', name: 'AWS Bedrock', color: '#ff9900', icon: SiAmazonwebservices }
};

export function getProviderInfo(providerId) {
  if (!providerId) return { name: 'Provider', color: '#94a3b8', icon: null };
  const key = String(providerId).toLowerCase();
  if (key.includes('vertex')) return PROVIDER_MAP.vertex_ai;
  if (key.includes('openai')) return PROVIDER_MAP.openai;
  if (key.includes('bedrock') || key.includes('aws')) return PROVIDER_MAP.aws_bedrock;
  return PROVIDER_MAP[providerId] || { name: providerId, color: '#94a3b8', icon: null };
}

export const STATUS_COLORS = {
  completed: '#22c55e',
  processing: '#3b82f6',
  failed: '#ef4444',
  cancelled: '#ef4444',
  pending: '#f59e0b',
  queued: '#6b7280'
};


